export default {
  toPrice: (float) => {
    if (float === null) {
      return float
    } else if (float === 0) {
      return '$0.00'
    } else if (!float || isNaN(float) ) {
      return (this) ? '$0.00' : '---'
    }

    return float > 0 ? `$${float.toFixed(2)}` : `-$${Math.abs(float).toFixed(2)}`;
  }
}